import { useMemo } from 'react';
import { type ModalManagerItem, useModalManagerStore, ModalManagerStoreState } from './modalManagerStore';

const Z_INDEX_BASELINE = 100; // should match scss value in `_variables`

type ModalManagerForPage = Pick<ModalManagerStoreState, 'setModalOpened' | 'setModalClosed'> & {
  hasActiveModal: boolean;
};

type ModalManagerForModal = ModalManagerForPage & {
  isActiveModal: boolean;
  isModalOpen: boolean;
  zIndex?: number;
};

export function useModalManager(): ModalManagerForPage;
export function useModalManager(id: string): ModalManagerForModal;

export function useModalManager(id?: string) {
  const { modalStack, setModalOpened, setModalClosed } = useModalManagerStore();

  const { currentModal, indexOfCurrentModal } = useMemo(() => {
    const currentModal = modalStack.find(item => item.id === id);
    const indexOfCurrentModal = currentModal ? modalStack.indexOf(currentModal) : -1;
    return { currentModal, indexOfCurrentModal };
  }, [id, modalStack]);

  const activeModal = modalStack[modalStack.length - 1] as ModalManagerItem | undefined;

  return {
    hasActiveModal: !!activeModal,
    isActiveModal: id ? activeModal?.id === id : false,
    isModalOpen: id ? !!currentModal : false,
    setModalOpened,
    setModalClosed,
    zIndex: id && indexOfCurrentModal >= 0 ? Z_INDEX_BASELINE + indexOfCurrentModal : undefined
  };
}
